'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'face-awesome';
var width = 512;
var height = 512;
var aliases = ["gave-dandy"];
var unicode = 'e409';
var svgPathData = 'M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm192-32l0-24c0-2-.1-3.9-.4-5.8-4.2 3.6-9.6 5.8-15.6 5.8-13.3 0-24-10.7-24-24 0-6 2.2-11.4 5.8-15.6-1.9-.3-3.8-.4-5.8-.4-22.1 0-40 17.9-40 40l0 24 80 0zm-40-96c39.8 0 72 32.2 72 72l0 56-144 0 0-56c0-39.8 32.2-72 72-72zm216 72c-13.3 0-24-10.7-24-24 0-5.4 1.8-10.3 4.7-14.3-4.1-1.1-8.3-1.7-12.7-1.7-26.5 0-48 21.5-48 48l0 16 96 0 0-16c0-4.4-.6-8.7-1.7-12.7-4 3-8.9 4.7-14.3 4.7zm-32-72c44.2 0 80 35.8 80 80l0 48-160 0 0-48c0-44.2 35.8-80 80-80zm28.1 212.1c-8.1-2.7-16.8-4.1-25.8-4.1-39.2 0-71.9 27.3-80.2 64 44.1-.7 83.6-24 106.1-59.8zM128.8 288l287.2 0-4.2 19c-1 4.4-2.1 8.7-3.4 13-20.6 66.1-82 112-152.3 112S124.3 386.1 103.7 320c-1.3-4.2-2.5-8.6-3.4-13l-4.2-19 32.8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceAwesome = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;